import {OnDestroy, Pipe, PipeTransform} from '@angular/core';
import {Subscription} from 'rxjs';
import {AssetsService} from '../services/assets.service';
import {ImgEnum} from '../models/assets.model';

@Pipe({
  name: 'imageSrc',
  standalone: false
})
export class ImageSrcPipe implements PipeTransform, OnDestroy {
  private subscriptions = new Subscription();
  
  constructor(private assetsService: AssetsService) {
  }
  
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  
  transform(imageName: ImgEnum): string {
    if (!imageName) {
      return imageName;
    }
    
    const imageSrc = this.assetsService.getAssetSource(imageName);
    return !!imageSrc ? imageSrc : '' ;
  }

}
